/**
 * reservedInstanceTagRelationship模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例


const reservedInstanceTagRelationship = {
  // 添加预留实例标签
  addRelationship(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstanceTagRelationship/addRelationship`, params);
  },
  // 查询标签
  queryTagList(params) {
    return $http.post(`${global.API_URL}/sme/reservedInstanceTagRelationship/queryTagList`, params);
  }
}

export default reservedInstanceTagRelationship;



// WEBPACK FOOTER //
// ./src/api/reservedInstanceTagRelationship.js